const GOOGLE_MAP_APIKEY = import.meta.env.VITE_GOOGLE_MAP_APIKEY
const API_GW_URL = import.meta.env.VITE_API_GW_URL
const API_GW_SSE_URL = import.meta.env.VITE_API_SSE_GW_URL
const BE_TIX_API_GW_URL = import.meta.env.VITE_BE_TIX_API_GW_URL || API_GW_URL
const ENV = import.meta.env.VITE_ENV || "development"
// Determine if running in dev mode (Vite dev server)
// VITE_DEV_MODE is set to "1" during pnpm dev, undefined in production builds
const IS_DEV_MODE =
  import.meta.env.DEV || Number(import.meta.env.VITE_DEV_MODE) === 1

// Use proxy paths in development to bypass CORS
// The Vite dev server proxies /gw/* to the API gateway
const API_BASE_URL = IS_DEV_MODE ? "/gw" : API_GW_URL
const SSE_BASE_URL = IS_DEV_MODE ? "/gw-sse" : API_GW_SSE_URL

function joinApiUrl(baseUrl: string | undefined, path: string) {
  const base = (baseUrl || "").replace(/\/+$/, "")
  const normalizedPath = path.replace(/^\/+/, "")
  return base ? `${base}/${normalizedPath}` : `/${normalizedPath}`
}

const BE_TIX_API_BASE_URL = IS_DEV_MODE
  ? "/be-tix-api"
  : joinApiUrl(BE_TIX_API_GW_URL, "api/v1/be-bus/zma")

const DISPLAY_VERSION = __APP_VERSION__ ?? "development"

const APP_VERSION = DISPLAY_VERSION

const FIREBALL_SSE_PATH = import.meta.env.VITE_FIREBALL_SSE_PATH

const REGULATIONS_URL =
  import.meta.env.VITE_REGULATIONS_URL ||
  "https://be.com.vn/ho-tro/quy-che-hoat-dong/#v-pills-1"
const CONTRACT_URL =
  import.meta.env.VITE_CONTRACT_URL ||
  "https://be.com.vn/tin-tuc/hop-dong-van-chuyen-hanh-khach-theo-hop-dong-dien-tu-bang-xe-o-to/"
const PRIVACY_REGULATION_URL =
  import.meta.env.VITE_PRIVACY_REGULATION_URL ||
  "https://be.com.vn/ho-tro/quy-che-hoat-dong/"

const MAP_LIBRARIES = ["geometry"]

const ACCESS_TOKEN_KEY = "be_access_token"

const PHONE_REGEX = /(0[3|5|7|8|9])+([0-9]{8})\b/g

const DEVICE_TYPE = "web"
const BE_CLIENT_ID = import.meta.env.VITE_BE_CLIENT_ID || ""
const BE_OPERATOR_TOKEN = import.meta.env.VITE_BE_OPERATOR_TOKEN || ""
const BE_OPERATOR_ID = Number(import.meta.env.VITE_BE_OPERATOR_ID || 0) || 0

const RATINGS = [
  {
    normal: "/icons/rating/ic_rating_good.png",
    active: "/icons/rating/ic_rating_good_selected.png",
  },
  {
    normal: "/icons/rating/ic_rating_toobad.png",
    active: "/icons/rating/ic_rating_toobad_selected.png",
  },
  {
    normal: "/icons/rating/ic_rating_bad.png",
    active: "/icons/rating/ic_rating_bad_selected.png",
  },
  {
    normal: "/icons/rating/ic_rating_normal.png",
    active: "/icons/rating/ic_rating_normal_selected.png",
  },
  {
    normal: "/icons/rating/ic_rating_good.png",
    active: "/icons/rating/ic_rating_good_selected.png",
  },
  {
    normal: "/icons/rating/ic_rating_excellent.png",
    active: "/icons/rating/ic_rating_excellent_selected.png",
  },
]

const TZ = "Asia/Ho_Chi_Minh"

const DISABLE_ADD_PAYMENT_METHOD =
  import.meta.env.VITE_DISABLE_ADD_PAYMENT_METHOD ?? false

const ALLOWED_REDIRECT_PATHS = {
  "/ride/dropoff_location": true,
}

const GOOGLE_MAP_STYLE = [
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#7a8099",
      },
    ],
  },
  {
    featureType: "landscape",
    stylers: [
      {
        color: "#f2f2f2",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fcfbfa",
      },
    ],
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fcfbfa",
      },
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "landscape.natural",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6a6e73",
      },
    ],
  },
  {
    featureType: "poi.attraction",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi.attraction",
    elementType: "labels.icon",
    stylers: [
      {
        color: "#4e5e9d",
      },
    ],
  },
  {
    featureType: "poi.attraction",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#3e649a",
      },
    ],
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.business",
    elementType: "labels.icon",
    stylers: [
      {
        color: "#849ca1",
      },
    ],
  },
  {
    featureType: "poi.medical",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi.medical",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi.medical",
    elementType: "labels.icon",
    stylers: [
      {
        color: "#e46782",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi.place_of_worship",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.school",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#f8eded",
      },
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.school",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#e1e6ed",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#ced1d9",
      },
      {
        visibility: "on",
      },
      {
        weight: "1",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#80868b",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffe15f",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#efd151",
      },
      {
        visibility: "on",
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#dfe4eb",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#d3dbe0",
      },
      {
        visibility: "off",
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#81868b",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.icon",
    stylers: [
      {
        saturation: -30,
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit.station.airport",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#f2efed",
      },
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit.station.airport",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#d3d7e0",
      },
    ],
  },
  {
    featureType: "transit.station.bus",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#a2daf2" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#a2daf2",
      },
      {
        weight: 1,
      },
    ],
  },
]

const MAPTILE_URL = import.meta.env.VITE_MAPTILE_URL

export {
  API_GW_URL,
  API_GW_SSE_URL,
  BE_TIX_API_BASE_URL,
  BE_TIX_API_GW_URL,
  API_BASE_URL,
  SSE_BASE_URL,
  APP_VERSION,
  CONTRACT_URL,
  ENV,
  FIREBALL_SSE_PATH,
  GOOGLE_MAP_APIKEY,
  PRIVACY_REGULATION_URL,
  REGULATIONS_URL,
  MAP_LIBRARIES,
  ACCESS_TOKEN_KEY,
  PHONE_REGEX,
  DEVICE_TYPE,
  BE_CLIENT_ID,
  BE_OPERATOR_TOKEN,
  BE_OPERATOR_ID,
  RATINGS,
  TZ,
  IS_DEV_MODE,
  DISPLAY_VERSION,
  DISABLE_ADD_PAYMENT_METHOD,
  ALLOWED_REDIRECT_PATHS,
  GOOGLE_MAP_STYLE,
  MAPTILE_URL,
}
